import React, {useState} from 'react';
import {DndContext , DragEndEvent} from '@dnd-kit/core';

import {Droppable} from './Droppable';
import {Draggable} from './Draggable';

export default function DragDrop() {
  const containers = ['A', 'B', 'C'];
  const fruits = ["Apple", "Banana", "Lemon", "Pear", "Mango"];
  const [cartItems, setCartItems] = useState([]);
  const [parent, setParent] = useState(null);
  const draggableMarkup = (
    <Draggable id="draggable">Drag me</Draggable>
  );

  return (
    <DndContext onDragEnd={handleDragEnd}>
      <div>
      <h1>Fruit List</h1>
          <ul >
            {fruits.map((fruit) => (
              <Draggable key={fruit}>{fruit}</Draggable>
            ))}
          </ul>
          </div>
          <div >
          <h1>My Cart</h1>
          <Droppable items={cartItems} />
        </div>
    </DndContext>
  );
    function handleDragEnd(event) {
      const {over} = event;

    // If the item is dropped over a container, set it as the parent
    // otherwise reset the parent to `null`
    setParent(over ? over.id : null);
    console.log("Geldi",event,over);
    }
}
